<div class="wrapper">
  <div class="heading text-type-6">{{ data.control_form.name }}</div>
  @for (line of summaryLines; track line) {
    <div class="summary-line text-type-10">{{ line }}</div>
  }
  <div class="filed-on text-type-10">
    {{ data?.created_at | date: 'hh:mm a on MMMM dd, yyyy' }}
  </div>
  @if (data?.map_feature_link?.sheet) {
    <!-- A linked sheet is a one-line chip on the tile; the record's side panel keeps the full card and Open sheet -->
    <app-design-context-chips [link]="data.map_feature_link" />
  } @else if (data?.map_feature_link) {
    <app-design-context class="card-design-context" [link]="data.map_feature_link" [editable]="false" [projectId]="projectId$ | async" />
  }
  @if (displayMatched) {
    <div
      class="matched text-type-15">{{ matchedNo }} {{ matchedNo > 1 ? 'occurrences' : 'occurrence' }}
    </div>
  }
</div>
